import { FC } from "react";
import { useChatStore } from "../../../stores/ChatStore";
import { ChatGroupMessage, ChatMessage } from "../../../interfaces/Chat/Chat";
import { returnMaps } from "../../General/ChatElement";
import { useIntl } from "react-intl";
import { formatText } from "../../../functions/general";

interface ChatReplyProps {
    message: ChatMessage | ChatGroupMessage
    scrollToChat: (index: number) => void
}

const ChatReply: FC<ChatReplyProps> = ({ message, scrollToChat }) => {
    const intl = useIntl()
    const { listChatMessages, listChatRooms, listChatGroupMessages, listChatGroupParticipants, listChatGroupRooms, menuActive, phoneNumber, groupID, messages, groupMessages } = useChatStore()
    let colorMessage = ''

    const chekMenuActive = (): ChatMessage | ChatGroupMessage | undefined => {
        if (menuActive === "chat") {
            if (listChatMessages[phoneNumber]) return listChatMessages[phoneNumber].find(data => data.id === message.idReference)
            else return undefined
        } else if (menuActive === "chat-group") {
            if (listChatGroupMessages[groupID]) {
                const data = listChatGroupMessages[groupID].find(data => data.id === message.idReference)
                if (data) colorMessage = listChatGroupParticipants[(data as ChatGroupMessage).waSender.phone].color
                return data
            }
            else return undefined
        }
    }

    const referenceMessage = chekMenuActive()

    const handleReplyClick = () => {
        const indexChat = messages.findIndex(originalMessage => originalMessage.id === message.idReference);
        const indexChatGroup = groupMessages.findIndex(originalMessage => originalMessage.id === message.idReference);

        if (menuActive === "chat" && indexChat !== -1) {
            scrollToChat(indexChat)
        }

        if (menuActive === "chat-group" && indexChatGroup !== -1) {
            scrollToChat(indexChatGroup)
        }
    }

    return (
        <div onClick={handleReplyClick} className="cursor-pointer">
            {
                message.idReference && referenceMessage &&
                <div className="chat-reply bg-secondary p-3 rounded d-flex justify-content-between overflow-auto">
                    <div id='reply-content'>
                        {
                            menuActive === "chat" ?
                                <p id='reply-header' className='fw-bolder'>
                                    {referenceMessage.fromMe ? 'You' : listChatRooms[phoneNumber].roomName}
                                </p>
                                :
                                <p id='reply-header' className='fw-bolder' style={{ color: colorMessage }}>
                                    {referenceMessage.fromMe ? 'You' : (referenceMessage as ChatGroupMessage).waSender.name}
                                </p>
                        }
                        <span id='reply-text text-primary'>
                            {
                                referenceMessage.attachmentName &&
                                <>
                                    {
                                        (referenceMessage.attachmentName.endsWith('.jpg') || referenceMessage.attachmentName.endsWith('.png') || referenceMessage.attachmentName.endsWith('.jpeg')) ?
                                            <span>
                                                <i className="fas fa-image me-1" />
                                                {referenceMessage.attachmentName}
                                            </span>
                                            :
                                            (referenceMessage.attachmentName!.endsWith('.mp4') || referenceMessage.attachmentName!.endsWith('.mov')) ?
                                                <span>
                                                    <i className="fas fa-video me-1" />
                                                    {referenceMessage.attachmentName}
                                                </span>
                                                :
                                                referenceMessage.attachmentName &&
                                                <span>
                                                    <i className="fas fa-file me-1" />
                                                    {referenceMessage.attachmentName}
                                                </span>
                                    }
                                </>
                            }
                            {
                                referenceMessage.message.includes('[User sends location]') &&
                                returnMaps(referenceMessage, listChatGroupParticipants, listChatRooms[phoneNumber], intl, "chatReply")
                            }
                            {
                                referenceMessage.message && !referenceMessage.message.includes('[User sends location]') &&
                                <span id='reply-text'>
                                    <div style={{ margin: '0' }} dangerouslySetInnerHTML={{ __html: formatText(referenceMessage.message, listChatGroupParticipants, listChatRooms[phoneNumber], false, true) }} className='fw-normal' />
                                </span>
                            }
                        </span>
                    </div>
                </div>
            }
        </div>
    )
}

export { ChatReply }